import {useIdVerificationStep} from './useIdVerificationStep'
import {useAcceptTermsStep} from './useAcceptTermsStep'
import {useConnectAccountingProviderStep} from './useConnectAccountingProviderStep'

export const useSteps = (stepperData) => {
  const connectAccountingProviderStep =
    useConnectAccountingProviderStep(stepperData)
  const acceptTermsStep = useAcceptTermsStep(stepperData)
  const verifyIdStep = useIdVerificationStep(stepperData)

  return [connectAccountingProviderStep, acceptTermsStep, verifyIdStep]
}
